import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import React, { memo } from "react";
import SectionContainer from "../../../../../common/SectionContainer";
import { Data } from "../../../../../store/terminal/types";
import { FormikProps, useFormikContext } from "formik";
import TextInput from "../../../../../common/formElements/TextInput";

interface EditBPGiftCardSupportFormProps {
  bulk: boolean;
  isUpdateAllowed?: boolean;
}

function EditBPGiftCardSupportForm({
  bulk,
  isUpdateAllowed,
}: EditBPGiftCardSupportFormProps) {
  const formProps = useFormikContext<FormikProps<Data>>();
  const { setFieldValue } = formProps;
  const values = (formProps.values as unknown) as Data;
  const bpGiftCardConfig = values.attributes.BPGiftCardsConfig;

  return (
    <SectionContainer
      heading="BP Gift Card Configuration"
      name="sections.bpgiftcardconfiguration"
      bulk={bulk}
    >
      <Grid container alignItems="flex-start" spacing={2}>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <TextInput
              required
              fieldname="attributes.BPGiftCardsConfig.Username"
              label="Username"
              disabled={!isUpdateAllowed}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <TextInput
              required
              fieldname="attributes.BPGiftCardsConfig.Password"
              label="Password"
              disabled={!isUpdateAllowed}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <TextInput
              required
              fieldname="attributes.BPGiftCardsConfig.LegacyPassword"
              label="Legacy Password"
              disabled={!isUpdateAllowed}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <TextInput
              required
              fieldname="attributes.BPGiftCardsConfig.LegacyUsername"
              label="Legacy Username"
              disabled={!isUpdateAllowed}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <TextInput
              required
              fieldname="attributes.BPGiftCardsConfig.ShopId"
              label="Shop ID"
              disabled={!isUpdateAllowed}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <TextInput
              required
              fieldname="attributes.BPGiftCardsConfig.TillId"
              label="Till ID"
              disabled={!isUpdateAllowed}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <TextInput
              required
              fieldname="attributes.BPGiftCardsConfig.TerminalId"
              label="Terminal ID"
              disabled={!isUpdateAllowed}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth>
            <TextInput
              required
              fieldname="attributes.BPGiftCardsConfig.LegacyTerminalId"
              label="Legacy Terminal ID"
              disabled={!isUpdateAllowed}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl fullWidth variant="outlined">
            <InputLabel>Currency</InputLabel>
            <Select
              required
              label="Currency"
              variant="outlined"
              value={bpGiftCardConfig?.Currency}
              onChange={(event) => {
                setFieldValue(
                  "attributes.BPGiftCardsConfig.Currency",
                  event.target.value
                );
              }}
              disabled={!isUpdateAllowed}
            >
              <MenuItem value="">Disabled</MenuItem>
              <MenuItem value="AUD">AUD</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </SectionContainer>
  );
}
export default memo(EditBPGiftCardSupportForm);
